import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { NavLink } from 'react-router-dom'
import ImmutablePropTypes from 'react-immutable-proptypes'
import ImmutablePureComponent from 'react-immutable-pure-component'
import { CX, MODAL_DISPLAY_OPTIONS, MODAL_PRO_UPGRADE } from '../constants'
import Avatar from './avatar'
import DisplayName from './display_name'
import Button from './button'
import Text from './text'
import List from './list'
import { closeSidebar } from '../actions/sidebar'
import { openModal } from '../actions/modal'
import { me, isPro } from '../initial_state'
import { makeGetAccount } from '../selectors'
import ShortcutsAvatarList from './shortcuts_avatar_list'
import { fetchManagedBusinesses } from '../actions/businesses'
import Image from './image'
import LinkFooter from './link_footer'

function MenuItemBlock({ icon, text, to, href, onClick }) {
  return (
    <Button
      radiusSmall
      icon={icon}
      to={to || undefined}
      href={href || undefined}
      onClick={onClick}
      iconSize='20px'
      color='primary'
      backgroundColor='primary'
      iconClassName={[_s.cPrimary, _s.fillPrimary].join(' ')}
      className={[_s.flexColumn, _s.aiStart].join(' ')}
    >
      <Text
        color='inherit'
        weight='medium'
        size='medium'
        className={[_s.w100PC, _s.pt10].join(' ')}
      >
        {text}
      </Text>
    </Button>
  )
}

class SidebarXS extends ImmutablePureComponent {

  componentDidMount() {
    this.props.onFetchManagedBusinesses()
  }

  componentDidUpdate () {
    if (!me) return

    if (this.props.sidebarOpen) {
      document.body.classList.add(_s.overflowYHidden)
    } else {
      document.body.classList.remove(_s.overflowYHidden)
    }
  }

  handleSidebarClose = () => {
    document.body.classList.remove(_s.overflowYHidden) 
    this.props.onCloseSidebar()
  }

  handleOnOpenProModal = () => {
    this.handleSidebarClose()
    this.props.onOpenProModal('gs-ms');
  }

  render () {
    const { sidebarOpen, account, shortcuts, managedBusinesses } = this.props

    if (!me || !account) return null

    const acct = account.get('acct')

    const containerClasses = CX({
      d: 1,
      posFixed: 1,
      top0: 1,
      left0: 1,
      right0: 1,
      bottom0: 1,
      z5: 1,
      displayNone: !sidebarOpen,
    })

    return (
      <div className={containerClasses}>
        <div className={[_s.d, _s.posFixed, _s.top0, _s.left0, _s.right0, _s.bgBlackOpaquer, _s.bottom0].join(' ')} role='button' onClick={this.handleSidebarClose} />
        <div className={[_s.defaut, _s.posFixed, _s.maxW80VW, _s.w330PX, _s.right0, _s.top0, _s.bottom0, _s.bgSubtle, _s.saveAreaInsetPT, _s.saveAreaInsetPB, _s.saveAreaInsetPL, _s.borderRight1PX, _s.borderColorSecondary, _s.maxW80PC, _s.overflowYScroll].join(' ')}>

          <div className={[_s.d, _s.w100PC, _s.px10, _s.pt7].join(' ')}>
            <div className={[_s.d, _s.flexRow, _s.jcCenter, _s.w100PC, _s.h40PX].join(' ')}>
              <Text size='extraExtraLarge' weight='bold' className={_s.pt2}>Menu</Text>
              <div className={[_s.d, _s.flexRow, _s.mlAuto].join(' ')}>
                <Button
                  title='Settings'
                  color='primary'
                  href='/settings/preferences'
                  backgroundColor='tertiary'
                  onClick={this.handleSidebarClose}
                  icon='cog'
                  iconSize='16px'
                  className={[_s.w40PX, _s.h40PX, _s.mr5, _s.aiCenter, _s.jcCenter].join(' ')}
                />
                <Button
                  title='Search Gab'
                  color='primary'
                  to='/search'
                  backgroundColor='tertiary'
                  onClick={this.handleSidebarClose}
                  icon='search'
                  iconSize='16px'
                  className={[_s.w40PX, _s.h40PX, _s.mr5, _s.aiCenter, _s.jcCenter].join(' ')}
                />
                <Button
                  title='Close menu'
                  color='primary'
                  backgroundColor='tertiary'
                  onClick={this.handleSidebarClose}
                  icon='close'
                  iconSize='14px'
                  className={[_s.w40PX, _s.h40PX, _s.aiCenter, _s.jcCenter].join(' ')}
                />
              </div>
            </div>
          </div>

          <div className={[_s.d, _s.w100PC, _s.px10, _s.py15].join(' ')}>
            <NavLink
              to={`/${acct}`}
              title={acct}
              onClick={this.handleSidebarClose}
              className={[_s.d, _s.w100PC, _s.bgPrimary, _s.noUnderline, _s.aiCenter, _s.overflowHidden, _s.boxShadowBlock, _s.flexRow, _s.radiusSmall, _s.px10, _s.py10].join(' ')}
            >
              <Avatar account={account} size='40' />
              <div className={[_s.d, _s.ml10, _s.noUnderline].join(' ')}>
                <DisplayName account={account} isMultiline />
              </div>
            </NavLink>
            {
              managedBusinesses && managedBusinesses.map((business) => {
                return (
                  <NavLink
                    onClick={this.handleSidebarClose}
                    className={[_s.d, _s.mt10, _s.overflowHidden, _s.flexRow, _s.cursorPointer, _s.border1PX, _s.borderColorSecondary, _s.boxShadowBlock, _s.noUnderline, _s.bgSubtle_onHover, _s.radiusSmall, _s.px5, _s.py10].join(' ')}
                    to={`/business/${business.get('id')}`}
                  >
                    <div className={[_s.d, _s.radiusTiny, _s.borderColorPrimary].join(' ')}>
                      <Image
                        src={business.get('logo_thumbnail_url')}
                        width={40}
                        height={40}
                        className={[_s.radiusTiny].join(' ')}
                      />
                    </div>
                    <div className={[_s.d, _s.ml10].join(' ')}>
                      <Text size='medium' weight='medium'>{business.get('name')}</Text>
                      <Text color='secondary' className={[_s.capitalize, _s.mt5].join(' ')}>{business.get('status')}</Text>
                    </div>
                  </NavLink>
                )
              })
            }
          </div>

          {
            (!!shortcuts && shortcuts.size > 0) &&
            <div className={[_s.d, _s.w100PC, _s.mb15].join(' ')} onClick={this.handleSidebarClose}>
              <div className={[_s.d, _s.w100PC, _s.px10, _s.flexRow, _s.aiCenter].join(' ')}>
                <Text weight='medium'>
                  Your shortcuts
                </Text>
                <NavLink to='/shortcuts' className={[_s.d, _s.mlAuto, _s.pr5, _s.noUnderline].join(' ')}>
                  <Text weight='bold' color='brand'>
                    All
                  </Text>
                </NavLink>
              </div>
              <ShortcutsAvatarList />
            </div>
          }

          <div className={[_s.d, _s.w100PC, _s.mb15].join(' ')}>
            <div className={[_s.d, _s.w100PC, _s.px10].join(' ')}>
              <div className={[_s.d, _s.w100PC, _s.borderColorSecondary, _s.borderTop1PX].join(' ')} />
            </div>
            <div
              className={[_s.d, _s.pt15, _s.displayGrid, _s.px10].join(' ')}
              style={{
                gridGap: '5px',
                gridTemplateColumns: `repeat(auto-fill, minmax(120px, 1fr))`,
              }}
            >
              <MenuItemBlock icon='shop' text='Marketplace' to='/marketplace' onClick={this.handleSidebarClose} />
              <MenuItemBlock icon='shop' text='Businesses' to='/businesses' onClick={this.handleSidebarClose} />
              <MenuItemBlock icon='pro' text='Pro Timeline' to='/timeline/pro' onClick={this.handleSidebarClose} />
              <MenuItemBlock icon='chat' text='Chats' to='/messages' onClick={this.handleSidebarClose} />
              <MenuItemBlock icon='group' text='Suggestions' to='/suggestions' onClick={this.handleSidebarClose} />
              <MenuItemBlock icon='light-bulb' text='Display options' onClick={this.props.onOpenDisplayModel} />
              <MenuItemBlock icon='bookmark' text='Bookmarks' to={`/${account.get('acct')}/bookmarks`} onClick={this.handleSidebarClose} />
              <MenuItemBlock icon='apps' text='Clips' to='/timeline/clips' onClick={this.handleSidebarClose} />
              <MenuItemBlock icon='news' text='News' to='/news' onClick={this.handleSidebarClose} />
              <MenuItemBlock icon='list' text='Feeds' to='/feeds' onClick={this.handleSidebarClose} />
              <MenuItemBlock icon='ai-robot' text='Gab.AI' href='https://gab.ai?f=gs-ms' onClick={this.handleSidebarClose} />
              <MenuItemBlock icon='tv' text='Gab TV' to='/timeline/videos' onClick={this.handleSidebarClose} />

            </div>
          </div>

          <div className={[_s.d, _s.w100PC, _s.px10, _s.pb15].join(' ')}>
            <Button
              radiusSmall
              icon='pencil'
              to='/compose'
              iconClassName={_s.mr10}
              className={[_s.aiCenter, _s.jcCenter].join(' ')}
            >
              <Text color='inherit' weight='medium'>Compose</Text>
            </Button>
          </div>

          <div className={[_s.d, _s.boxShadowNone, _s.w100PC].join(' ')}>
            <List
              items={[
                {
                  href: '/settings/preferences',
                  onClick: this.handleSidebarClose,
                  title: 'Account Settings',
                },
                !isPro && {
                  onClick: this.handleOnOpenProModal,
                  title: 'Go GabPRO',
                },
                {
                  href: 'https://shop.dissenter.com',
                  onClick: this.handleSidebarClose,
                  title: 'Visit the Dissenter Shop',
                },
                {
                  href: 'https://help.gab.com/article/gab-mobile-app',
                  onClick: this.handleSidebarClose,
                  title: 'Gab Mobile App',
                },
                {
                  href: 'https://grow.gab.com',
                  onClick: this.handleSidebarClose,
                  title: 'Advertise on Gab',
                },
                {
                  href: '/settings/blocks',
                  onClick: this.handleSidebarClose,
                  title: 'Blocked accounts',
                },
                {
                  href: '/settings/mutes',
                  onClick: this.handleSidebarClose,
                  title: 'Muted accounts',
                },
                {
                  href: 'https://help.gab.com',
                  onClick: this.handleSidebarClose,
                  title: 'Help & Support',
                },                
              ].filter(Boolean)}
            />
          </div>
          
          <div className={[_s.d, _s.w100PC, _s.pt10, _s.px10].join(' ')}>
            <LinkFooter />
          </div>
          
          <div className={[_s.d, _s.w100PC, _s.pb15, _s.mt15, _s.mb10, _s.px10].join(' ')}>
            <Button
              isBlock
              radiusSmall
              color='primary'
              backgroundColor='tertiary'
              href='/auth/sign_out'
              className={[_s.d, _s.aiCenter, _s.jcCenter].join(' ')}
            >
              <Text color='inherit' weight='medium'>Log out</Text>
            </Button>
          </div>

        </div>
      </div>
    )
  }

}

const mapStateToProps = (state) => {
  const managedBusinessIds = state.getIn(['business_lists', 'managed', 'items'])
  const managedBusinesses = !!managedBusinessIds ? managedBusinessIds.map((bizId) => {
    return state.getIn(['businesses', 'items', bizId])
  }) : null

  return {
    account: makeGetAccount()(state, me),
    shortcuts: state.getIn(['shortcuts', 'items']),
    sidebarOpen: state.get('sidebar').open,
    managedBusinesses,
  }
}

const mapDispatchToProps = (dispatch) => ({
  onCloseSidebar: () => dispatch(closeSidebar()),
  onOpenDisplayModel() {
    dispatch(closeSidebar())
    dispatch(openModal(MODAL_DISPLAY_OPTIONS))
  },
  onFetchManagedBusinesses() {
    dispatch(fetchManagedBusinesses())
  },
  onOpenProModal(subtitle) {
    dispatch(openModal(MODAL_PRO_UPGRADE, { subtitle }))
  },
})

SidebarXS.propTypes = {
  account: ImmutablePropTypes.map,
  sidebarOpen: PropTypes.bool,
  onCloseSidebar: PropTypes.func.isRequired,
  onOpenDisplayModel: PropTypes.func.isRequired,
}

export default connect(mapStateToProps, mapDispatchToProps)(SidebarXS)
